/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';
import { IParticipantes } from './InternalTraining';

export interface ISeminario {
    uuid?: string | undefined;
    participantes?: IParticipantes[];
    frequentadores?: IFrequentadores[];
    id_barragem?: string,
    periodo_referencia: string,
    data_seminario: string,
    responsavel_tecnico?: string,
    art?: string,
    instituicoes_participantes?: string,
}

export interface IFrequentadores {
    nome?: string;
    id_unidade?: string;
    tipologia_unidade?: string;
    contato?: string;
    id_seminario?: string;
    id_simulado?: string;
}

const create = async (data: ISeminario): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/seminario', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo seminario');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo seminario');
        }
    }
};

const upgrade = async (data: ISeminario, uuid: string): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`/seminario?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo seminario');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo seminario');
        }
    }
};

const list = async (uuid: string): Promise<ISeminario[] | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/seminarios?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar seminarios');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar seminarios');
        }
    }
};

const get = async (uuid: string): Promise<ISeminario | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/seminario?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar ACO');
        }
    }

};

const delet = async (uuid: string): Promise<string | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`/aco?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar ACO');
        }
    }
};


export const SeminarioServices = {
    create,
    list,
    get,
    delet,
    upgrade
};